import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "selling-points" }
const _hoisted_2 = { class: "container header-padding-compensation" }
const _hoisted_3 = { class: "border-photo-container" }
const _hoisted_4 = { class: "background" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-7" }
const _hoisted_7 = { class: "usp-point d-flex align-items-center usp-margin-bottom" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-check" }, null, -1)
const _hoisted_9 = { class: "usp-point d-flex align-items-center usp-margin-bottom" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-check" }, null, -1)
const _hoisted_11 = { class: "usp-point d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-check" }, null, -1)
const _hoisted_13 = { class: "col-12 col-lg-5 position-relative" }
const _hoisted_14 = { class: "image-container" }
const _hoisted_15 = ["srcset"]
const _hoisted_16 = ["srcset"]
const _hoisted_17 = ["srcset"]
const _hoisted_18 = ["srcset"]
const _hoisted_19 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('website.usp-1')), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('website.usp-2')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('website.usp-3')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("picture", null, [
                  _createElementVNode("source", {
                    media: "only screen and (min-width: 1200px)",
                    srcset: _ctx.$imgix('img/usp-girl2.jpg?w=445&h=350&auto=compress,format&fit=crop')
                  }, null, 8, _hoisted_15),
                  _createElementVNode("source", {
                    media: "only screen and (min-width: 992px)",
                    srcset: _ctx.$imgix('img/usp-girl2.jpg?w=375&h=330&auto=compress,format&fit=crop')
                  }, null, 8, _hoisted_16),
                  _createElementVNode("source", {
                    media: "only screen and (min-width: 768px)",
                    srcset: _ctx.$imgix('img/usp-girl_md2.jpg?w=590&h=350&auto=compress,format&fit=crop')
                  }, null, 8, _hoisted_17),
                  _createElementVNode("source", {
                    media: "only screen and (min-width: 576px)",
                    srcset: _ctx.$imgix('img/usp-girl2.jpg?w=445&h=350&auto=compress,format&fit=crop')
                  }, null, 8, _hoisted_18),
                  _createElementVNode("img", {
                    src: _ctx.$imgix('img/usp-girl2.jpg?w=445&h=350&auto=compress,format&fit=crop'),
                    alt: _ctx.$t('website.couple'),
                    width: "445",
                    height: "350"
                  }, null, 8, _hoisted_19)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}